import React from 'react';
import { Typography } from '@mui/material';

/** True while focus sits in any typing surface — single-letter shortcuts
 * must never fire there (same guard as useTableKeyboardNavigation). */
export const isTypingContext = (): boolean => {
  const active = document.activeElement;
  if (!active) return false;
  const tag = active.tagName.toLowerCase();
  return (
    tag === 'input' ||
    tag === 'textarea' ||
    tag === 'select' ||
    active.getAttribute('role') === 'combobox' ||
    active.getAttribute('contenteditable') === 'true'
  );
};

export const isMacPlatform = (): boolean =>
  typeof navigator !== 'undefined' && /mac/i.test(navigator.platform);

/** Display label for the save-while-focused chord (⌘↵ on Mac, Ctrl+↵ elsewhere). */
export const modEnterHint = (): string => (isMacPlatform() ? '⌘↵' : 'Ctrl+↵');

/** Inline kbd chip inside actionable controls — same affordance as the
 * dashboard preview panel's verdict buttons. */
export const KeyHint = ({ k }: { k: string }) => (
  <Typography
    component="kbd"
    variant="caption"
    sx={{
      ml: 0.75,
      px: 0.5,
      border: 1,
      borderColor: 'divider',
      borderRadius: '4px',
      lineHeight: 1.4,
    }}
  >
    {k}
  </Typography>
);
